import { DraftInvoice, PropsWithUser } from "@/types";
import { PublishInvoiceForm } from "./_publish_form";

type Props = PropsWithUser & {
  draft_invoice: DraftInvoice;
};

export default function DraftInvoiceShow({ draft_invoice }: Props) {
  return (
    <div className="grid grid-cols-[1fr_400px] gap-4">
      <iframe src={draft_invoice.file_url} className="h-full w-full" />

      <PublishInvoiceForm key={draft_invoice.id} draftInvoice={draft_invoice} />
    </div>
  );
}
